const backgraundColorList = [
    '#00ff7a14',
    '#001bff14',
    '#d600ff14',
    '#61ff0014',
    '#fff50014',
    '#ff580014',
    '#ff000014',
    '#009dff14'
];

export default backgraundColorList;